import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="grid-bg min-h-[80vh] flex items-center justify-center px-5">
      <div className="glass rounded-2xl p-12 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle weight="fill" size={72} className="text-white/30 mx-auto mb-6" />
        <h1 className="font-display font-black text-2xl uppercase tracking-tight">Checkout cancelled</h1>
        <p className="text-white/60 mt-4">No charge made. Your home screen remains tragically default.</p>
        <Link to="/premium"
          className="inline-flex items-center gap-2 bg-[#FFEB3B] text-[#05050A] font-bold px-6 py-3.5 rounded-sm mt-8 hover:bg-[#fff35c] transition-colors">
          Try again
        </Link>
      </div>
    </div>
  );
}
